export const API_BASE_URL = 'https://api.travel.origami-plus.com';
export const STAMP_ICON_BASE_URL = 'https://cdn.travel.origami-plus.com/stamp/icon';
export const APP_NAME = 'Origami+ Travel 管理画面';
